module.exports = __webpack_public_path__ + "img/RBS04_3.155ecff3.jpg";